module.exports = __webpack_public_path__ + "static/mpost54.f22c85a9.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/slideshow/mpost54.jpg
// module id = 256
// module chunks = 23899280101116 35783957827783